import styled from 'styled-components';

export const HeaderTitle = styled.h1`
  font-size: 20px;
  font-weight: 600;
  color: ${(props) => props.theme.textMainColor};

  @media (max-width: 710px) {
    font-size: 20px;
    font-weight: 600;
  }
`;

export const RequestHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;

  @media (max-width: 710px) {
    height: 50px;
    padding-left: 18px;
  }
`;
